import {UIComponent} from "@/engine/UI/UIComponent.js";
import {UITemplates} from "@/engine/UITemplates.js";

/** creates UI component 'List of commands'
 * that shows horizontal list of clickable icons
 *
 */
export class UICListCommand extends UIComponent {
    /**
     *
     * @param options {{items: [{item: {name: string, content: string | UIComponent, onSelect: function}}], defaultItem: number}}
     * @param view
     */
    constructor(options, view = "listCommandsWindowContent") {
        let o = Object.assign({
            id: (options.id === undefined) ? 'list' : options.id,
            title: (options.title === undefined) ? 'commands list' : options.title,
            iconBig: UITemplates.getContent('svg-my-device'),
            cancelActionName: (options.cancelActionName === undefined) ? 'CANCEL' : options.cancelActionName,
            callContainerClose: true
        }, options)

        super(o, view);
        this.contentData = this._contentData
    }

    open(container, parent, data) {
        super.open(container, parent)

        this.containerElement.querySelectorAll(".list input[type=radio]").forEach(function (el) {
            el.addEventListener("change", this._onItemClick.bind(this));
        }.bind(this));
    }

    close(onCancel) {
        if (this.containerElement)
            this.containerElement.querySelectorAll(".list input[type=radio]").forEach(function (el) {
                el.removeEventListener("change", this._onItemClick.bind(this));
            }.bind(this));
        super.close(onCancel)
    }

    _contentData() {
        let radioList = []
        let labelList = []
        for (let i = 0; i < this.items.length; i++) {
            if (this.items[i].content instanceof UIComponent) {
                if (! this.items[i].name)
                    this.items[i].name = this.items[i].content.title
                if (! this.items[i].picture)
                    this.items[i].picture = this.items[i].content.iconBig
            }
            if (this.items[i] instanceof UIComponent) {
                let uic = this.items[i]
                this.items[i] = {
                    name: uic.title,
                    picture: uic.iconBig,
                    content: uic
                }
            }

            if (this.items[i].content instanceof UIComponent) {
//                this.items[i].content.afterClose.push(function () {
//                    this.parent.createUICDialog(this)
//                }.bind(this))
            }
            radioList.push({listId: this._listId(i)})
            labelList.push({listId: this._listId(i), label: this.items[i].name, picture: this.items[i].picture})
        }
        return {
            radioList: radioList,
            labelList: labelList,
            descr: this.descr
        }
    }

    _listIdPrefix() {
        return this.id+'-'+'list'+'-'
    }

    _listId(id) {
        return this._listIdPrefix()+id
    }

    _onItemClick(ev) {
        let a = ev.target.id.split('-')
        let id = a[a.length-1]
        if (typeof this.items[id].onSelect === "function") {
            if (this.items[id].onSelect.bind(this)(id)) {
                this.close()
            }
        } else if (this.items[id].content instanceof UIComponent) {
            let uic = this.items[id].content
            // creates child dialog if item content is a UIComponent
            if (this.factory) {
                this.factory(uic, null, this)
            } else {
                console.log("ERROR", "factory method isn't defined")
            }
        }
    }
}
